import { Icon, IconProps } from '@chakra-ui/react'

export default function LampIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M6 14H10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99929 11.4393V12.15H5.99929V11.4393C5.99929 10.7347 5.67262 10.0767 5.12929 9.62732C4.18862 8.84799 3.56996 7.69465 3.50529 6.39332C3.38196 3.89932 5.43196 1.70665 7.92862 1.66865C10.4466 1.62932 12.5 3.65799 12.5 6.16665C12.5 7.56799 11.858 8.81732 10.8526 9.64132C10.3133 10.0833 9.99929 10.742 9.99929 11.4393Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.69336 10.2999H10.3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
